import React from 'react';
import { useTeam } from '../contexts/TeamContext';
import TeamNotFound from './TeamNotFound';
import UnlockTeam from './UnlockTeam';

const TeamScope = ({ children }) => {
  const { loading, error, teamId, locked, slug, slugMeta, teamData } = useTeam();

  if (loading) {
    return <div className="loading-screen">Učitavanje tima…</div>;
  }

  if (locked) {
    return (
      <UnlockTeam
        slug={slug}
        teamName={teamData?.name || slugMeta?.teamName || slug}
        passwordHash={teamData?.passwordHash || null}
        onUnlocked={() => window.location.reload()}
      />
    );
  }

  if (error || !teamId) {
    return <TeamNotFound />;
  }

  return <>{children}</>;
};

export default TeamScope;